import { useState, Fragment, useEffect } from 'react';
import { css } from 'twin.macro';
import { BsFillPlusSquareFill } from 'react-icons/bs';
import { CreateEventStyle } from '@/components/Admin/Tasks/Styles/EventModalStyles';
import { EventModalForm } from '@/components/Admin/Tasks/EventModalForm';
import styled from '@emotion/styled';

export const StyledCreateChannelToggle = styled.div`
    width: ${(props) => props.width || '100%'};
    height: ${(props) => props.height || '60px'};
    border-radius: ${(props) => props.borderRadius || '12px'};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #50aeb0;
    opacity: 1;
    :hover {
        box-shadow: rgba(100, 100, 111, 0.7) 0px 7px 20px 0px;
    }
`;
function EventModal({
    handleSubmitTask,
    customTeams,
    teamIds,
    createButtonStyle = {},
    showCreateEvent,
    toggleCreateEvent = () => {},
}) {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        toggleCreateEvent();
    };
    const handleShow = () => {
        setShow(true);
    };
    useEffect(() => {
        if (showCreateEvent) {
            handleShow();
        }
    }, [showCreateEvent]);
    return (
        <Fragment>
            {/* <div
                css={css`
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 10px;
                `}
                title="Create New Event"
            >
                <StyledCreateChannelToggle
                    onClick={handleShow}
                    width={createButtonStyle.width}
                    height={createButtonStyle.height}
                    borderRadius={createButtonStyle.borderRadius}
                >
                    <span>
                        <BsFillPlusSquareFill color="white" fontSize={30} />
                    </span>
                </StyledCreateChannelToggle>
            </div> */}

            <CreateEventStyle size="lg" centered show={show} onHide={handleClose}>
                <EventModalForm
                    handleSubmitTask={handleSubmitTask}
                    handleClose={handleClose}
                    mode={'create'}
                    showTeamFilter={true}
                    customTeams={customTeams}
                    teamIds={teamIds}
                />
            </CreateEventStyle>
        </Fragment>
    );
}
export default EventModal;
